import { SelectedInvestmentDTO } from "@models/managed-accounts/entities/step/setup";
import { some } from "lodash";

export const checkHasWeightZero = (
  selectedInvestments?: SelectedInvestmentDTO[],
): boolean =>
  some(selectedInvestments, (investment) => {
    const weight = investment.weight ?? 0;
    return weight === 0;
  });

export const compareSearchValues = (
  searchValues: string[],
  combinedSearchValues: string[],
): boolean => {
  return searchValues.every((searchValue) =>
    combinedSearchValues.some((combinedSearchValue) =>
      combinedSearchValue.includes(searchValue),
    ),
  );
};
